import {ActiveParticipantService} from '../../../../services/participants/active-participant.service';
import {Injectable, OnDestroy} from '@angular/core';
import {filter, tap} from 'rxjs/operators';
import {participantPages} from '../../../../pages/participant/participants.routes';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Injectable()
export class ProjectGuardService implements OnDestroy {

	private guardSubscription = new Subscription();

	constructor(
		protected activeParticipantService: ActiveParticipantService,
		protected router: Router,
	) {
		const preventEmptyParticipant = this.activeParticipantService.participant$.pipe(
			filter(p => !p),
			tap(() => this.routeUserToParticipantPage()),
		);
		this.guardSubscription.add(preventEmptyParticipant.subscribe());
	}

	private routeUserToParticipantPage(): void {
		this.router.navigate([participantPages.dashboard.base()]).catch(console.error);
	}

	ngOnDestroy(): void {
		this.guardSubscription.unsubscribe();
	}
}
